import {
    ADD_TASK_HISTORY,
    LOAD_TASK_HISTORY_BY_ID,
    LOAD_TASK_HISTORY_POSITION_BY_ID,
    LOAD_TASK_HISTORY_STATUS_BY_ID,
    LOAD_TASK_HISTORY_CREATED_BY_ID,
    LOAD_TASK_HISTORY_UPDATED_BY_ID,
    LOAD_TASK_HISTORY_VIEW_BY_ID,
    ADD_TASK_HISTORY_STATUS,
    ADD_TASK_HISTORY_WITH_STATUS_CREATED,
    ADD_TASK_HISTORY_WITH_STATUS_UPDATED,
    ADD_TASK_HISTORY_WITH_STATUS_VIEW
  } from '../../actions/taskHistory';
  
  export default function taskHistory(state = {}, action) {
    switch (action.type) {
      case ADD_TASK_HISTORY:
        return Object.assign({}, state, action.payload);
      case LOAD_TASK_HISTORY_BY_ID:
        return Object.assign({}, state, action.payload);
      case LOAD_TASK_HISTORY_POSITION_BY_ID:
        return Object.assign({}, state, action.payload);
      case LOAD_TASK_HISTORY_STATUS_BY_ID:
        return Object.assign({}, state, action.payload);
      case LOAD_TASK_HISTORY_CREATED_BY_ID:
        return Object.assign({}, state, action.payload);
      case LOAD_TASK_HISTORY_UPDATED_BY_ID:
        return Object.assign({}, state, action.payload);
      case LOAD_TASK_HISTORY_VIEW_BY_ID:
        return Object.assign({}, state, action.payload);
      case ADD_TASK_HISTORY_STATUS:
        return Object.assign({}, state, action.payload);
      case ADD_TASK_HISTORY_WITH_STATUS_CREATED:
        return Object.assign({}, state, action.payload);
      case ADD_TASK_HISTORY_WITH_STATUS_UPDATED:
        return Object.assign({}, state, action.payload);
      case ADD_TASK_HISTORY_WITH_STATUS_VIEW:
        return Object.assign({}, state, action.payload);
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/reducers/taskHistory/index.js